<template>
	<div id="openpay-charge">
		<ui-modal class="no-body" v-model="showingModal">

			<template slot="header">
				<div v-if="!storePaymentResponse.ordenId">
					Llena el formulario de recarga
				</div>
				<div v-else>
					Tu ticket de pago para finalizar tu recarga
				</div>
			</template>

			<template slot="footer">
				<div v-if="!!storePaymentResponse.ordenId">
					<div class="row row-end">
						<div class="col-tight" style="padding-right: 0.5em">
							<a :href="descargaFichaPago" target="_blank">
								<button class="dimmed">Descargar ficha de pago</button>
							</a>
						</div>
						<div class="col-tight">
							<button @click="showingModal = false">Finalizar</button>
						</div>
					</div>
				</div>

				<div v-else-if="!!deviceDataId">
					<button class="dimmed" v-if="!isProcessingCharge" @click="showingModal = false" >
						Cancelar
					</button>
					<button v-if="isProcessingCharge" key="processing" disabled>
						Procesando...
					</button>
					<button v-else @click="processForm()" key="normal">
						Continuar
					</button>
				</div>
			</template>

			<div id="storePaymentResponse" v-if="!!storePaymentResponse.ordenId">
				<div class="padding">
					<div class="main block">
						Cantidad:
						<strong>{{
							storePaymentResponse.amount | currency
						}}</strong>
					</div>
					<div class="main block">
						Vigencia:
						<strong>{{ storePaymentResponse.vigencia }}</strong>
					</div>
				</div>
				<div class="main block" v-if="!!storePaymentResponse.payment_method.barcode_url" >
					<img id="barcode" width="100%" :src="storePaymentResponse.payment_method.barcode_url" alt="" />
				</div>
				<div class="main block">
					Referencia:
					<strong>{{ storePaymentResponse.payment_method.reference }}</strong>
				</div>
				<img id="convenience" width="100%" src="public/images/conveniencia.png" alt="" />
				<hr />
				<div id="inModalOpenPay">
					<img src="public/images/openpay-color.77b290c.webp" alt="Openpay by BBVA" />
				</div>
			</div>

			<form v-else id="openpay-charge-form" @submit.prevent="processForm()">

				<div class="p-3">
					<ofertas-para-pago ref="opp" v-model="offerSelected"/>
					<!-- <code><pre>{{offerSelected}}</pre></code> -->
				</div>

				<!-- <h2>Selecciona tu modalidad de pago</h2> -->

				<b-form-group id="TipoDePago">

					<div class="payment-option" v-if="catalogosGetAppCFGs.openPaySllowStorePayments">
						<b-form-radio v-model="selectedTipoPago" name="some-radios" id="tipo1" :value="paymentStoreLabel">{{paymentStoreLabel}}</b-form-radio>
						<label for="tipo1">
							<img width="100%" src="public/images/conveniencia.png" alt="" />
						</label>
					</div>

					<div class="payment-option">
						<b-form-radio v-model="selectedTipoPago" name="some-radios" id="tipo0" :value="paymentVisaMCLabel">
							{{paymentVisaMCLabel}}
							<img src="public/images/cards1-noamex.png" alt="" />
						</b-form-radio>
						<label for="tipo0">
							<img width="100%" src="public/images/cards2.png" alt="" />
						</label>
					</div>

					<div class="payment-option">
						<b-form-radio v-model="selectedTipoPago" name="some-radios" id="tipo2" :value="paymentAmexLabel">
							{{paymentAmexLabel}}
							<img  src="public/images/cards1-soloamex.png" alt="" />
						</b-form-radio>
					</div>


				</b-form-group>

				<!-- FORMULARIO DE COMPRA -->
				<div id="FormUserData">
					<b-form-group key="datosUsuario">
						<b-row v-if="!isLogged">
							<b-col><ui-input v-model="userForm.name" label="Nombre" /></b-col>
							<b-col><ui-input v-model="userForm.last_name" label="Apellidos" /></b-col>
							<b-col><ui-input v-model="userForm.email" label="E-mail" /></b-col>
						</b-row>

						<b-row>
							<b-col><ui-input v-model="userForm.phone" label="Teléfono para recarga" type="phone" /></b-col>
							<b-col><ui-input v-if="!!userForm.phone" v-model="userForm.phone_confirm" label="Confirma el teléfono" type="phone" /></b-col>
						</b-row>
					</b-form-group>
				</div>
				<!-- FORMULARIO DE COMPRA -->

				<!-- FORMULARIO TARJETAS -->
				<div id="FormPaymentMethod" key="FormPaymentMethod" class="main-line animated zoomIn"
					v-if="selectedTipoPago != paymentStoreLabel">

					<h2>Datos de pago</h2>

					<b-form-group>

						<b-row>

							<b-col>
								<ui-input v-model="paymentForm.cardholder" label="Nombre en mi tarjeta" />
							</b-col>

							<b-col v-if="selectedTipoPago == paymentVisaMCLabel" key="card">
								<ui-input v-model="paymentForm.cardnumber" label="Número de tarjeta" type="card" />
							</b-col>
							<b-col v-if="selectedTipoPago == paymentAmexLabel" key="card-americanexpress">
								<ui-input v-model="paymentForm.cardnumber" label="Número American Express" type="card-americanexpress" />
							</b-col>

						</b-row>

						<b-row>

							<b-col>
								<ui-input v-model="paymentForm.date" label="Fecha de vencimiento" type="card-vigency"/>
							</b-col>

							<b-col>
								<ui-input class="cvv-input" v-model="paymentForm.cvv" label="CVV" type="card-cvv"/>
							</b-col>

						</b-row>

					</b-form-group>

					<!-- <h2>Domicilio</h2>

					<b-form-group>

						<b-row>
							<b-col>
								<ui-input v-model="paymentForm.address.state" label="Estado"/>
							</b-col>
							<b-col>
								<ui-input v-model="paymentForm.address.city" label="Ciudad"/>
							</b-col>
							<b-col>
								<ui-input v-model="paymentForm.address.postal_code" label="C. P."/>
							</b-col>
						</b-row>

						<b-row>
							<b-col cols="4">
								<ui-input v-model="paymentForm.address.line1" label="Colonia" />
							</b-col>
							<b-col>
								<ui-input v-model="paymentForm.address.line2" label="Calle y número"/>
							</b-col>
						</b-row>

						<ui-input v-model="paymentForm.address.line3" type="textarea" label="Referencia" />

					</b-form-group> -->

				</div>
				<!-- FORMULARIO TARJETAS -->

				<div class="openpay-locator">
					<strong>Tu pago será procesado por</strong>
					<img src="public/images/openpay-color.77b290c.webp" alt="Openpay by BBVA" />
				</div>
			</form>

		</ui-modal>
	</div>
</template>

<script>
import UiInput from './ui-input'
import _ from 'lodash'
import swal from "sweetalert";
import UiModal from "./ui-modal.vue";
import UiSelect from "./ui-select.vue";

import { mapActions, mapGetters } from "vuex";
import Axios from 'axios';
import OfertasParaPago from './ofertas-para-pago.vue';

const 	paymentVisaMCLabel = "Tarjeta de crédito/débito",
		paymentStoreLabel = "Pago en tiendas de convenienicia",
		paymentAmexLabel = "Américan Express";

let paymentTypes = [
		paymentVisaMCLabel,
		paymentStoreLabel,
		paymentAmexLabel,
	],
	
	// REMOVIDO  'Paypal',
	showingModal = false,
	selectedTipoPago = null,
	offerSelected = {
		type: null,
		offerId: null,
	},
	userForm = {
		name: null,
		last_name: null,
		phone: null,
		phone_confirm: null,
		email: null,
	},
	paymentIsSuccedded = false,
	paymentForm = {
		cardholder: "",
		cardnumber: "",
		date: "",
		cvv: "",
		// address: {
		// 	line1: null,
		// 	line2: null,
		// 	line3: null,
		// 	postal_code: null,
		// 	state: null,
		// 	city: null,
		// 	country_code: "MX",
		// },
	},
	storePaymentResponse = {
		ordenId: null,
		amount: null,
		vigencia: null,
		paymentId: null,
		payment_method: {},
	};

let fillWhileDev = false;

if (fillWhileDev) {
	storePaymentResponse = {
		ordenId: 101,
		amount: 33,
		vigencia: "2022-06-18 15:29:00",
		paymentId: "tr5du402f2pwytxrokew",
		payment_method: {
			type: "store",
			reference: "1010103441940455",
			barcode_url:
				"https://sandbox-api.openpay.mx/barcode/1010103441940455?width=1&height=45&text=false",
		},
	};
}

export default {
	components: { UiInput, UiModal, UiSelect, OfertasParaPago },
	name: "OpenPayCharge",
	data: () => {
		return {
			offerSelected: _.clone(offerSelected),
			selectedTipoPago,
			showingModal,
			userForm,
			paymentForm,
			paymentIsSuccedded,
			forpayment: null,
			isProcessingCharge: false,
			deviceDataId: null,
			storePaymentResponse: _.clone(storePaymentResponse),
			paymentVisaMCLabel,
			paymentStoreLabel,
			paymentAmexLabel
		};
	},
	computed: {
		...mapGetters(['OfertaGetCatalogo', 'isLogged', 'catalogosGetAppCFGs']),
		selectedPaymentTypes(){
			return paymentTypes
		},
		filtered(){
			return _.filter(this.OfertaGetCatalogo)
		},
		descargaFichaPago(){
			return Axios.defaults.baseURL + '/paynet/getpdf/' + this.storePaymentResponse.ordenId
		},
		openpayObj() {
			return {
				card_number: this.paymentForm.cardnumber.replace(/[ ]/g, ""),
				holder_name: this.paymentForm.cardholder,
				expiration_month: this.paymentForm.date.replace(/\/\d+/g, ""),
				expiration_year: this.paymentForm.date.replace(/\d+\//g, ""),
				cvv2: this.paymentForm.cvv.toString(),
				// address: _.clone(this.paymentForm.address),
			};
		},
	},
	methods: {
		...mapActions(["SkycelRecarga"]),
		
		async trigerPayment() {
			if (this.selectedTipoPago == paymentStoreLabel) {
				let response = await this.SkycelRecarga({
					openpayMethod: "store",
					purchaseObj: this.forpayment,
					userForm: this.userForm,
					// address: _.clone(this.paymentForm.address),
				});
				if (response.status) {
					this.storePaymentResponse = response.data;
				}
			} else {
				await this.processCardPurchase()
			}
		},
		
		async processCardPurchase() {
			let responseAPI = {
				status: false
			}
			return new Promise((success, fail) => {
				OpenPay.token.create(
					this.openpayObj,
					async (response) => {
						if (response.status == 200) {
							responseAPI = await this.SkycelRecarga({
								openpayId: response.data,
								openpayMethod: "card",
								purchaseObj: this.forpayment,
								deviceDataId: this.deviceDataId,
								userForm: this.userForm,
							});
							if(responseAPI.status){
								this.showingModal = false
								success(responseAPI);
							}
						}
						this.isProcessingCharge = false;
						fail(responseAPI);
					},
					(error) => {
						console.error("error", error);
						swal({
							icon: "warning",
							title: "Hay un error en la captura de información de pago.",
							text: error.data.description,
						});
						this.isProcessingCharge = false;
						fail(responseAPI);
					}
				);
			});
		},
		
		async processForm() {
			this.isProcessingCharge = true;
			if(!this.offerSelected.offerId){
				swal({
					icon: 'warning',
					title: 'Paquete no seleccionado.'
				})
			} else if(!this.selectedTipoPago){
				swal({
					icon: 'warning',
					title: 'Para continuar selecciona tu modalidad de pago.'
				})
			} else if(!this.userForm.phone || this.userForm.phone != this.userForm.phone_confirm){
				swal({
					icon: 'warning',
					title: 'El número de recarga de saldo o su confirmación son inválidas.',
					text: 'Por favor rectifica'
				})
			} else {
				await this.trigerPayment();
			}
			this.isProcessingCharge = false;
		},
		
		setForPayment(packDetails) {
			console.debug(packDetails)
			this.forpayment = packDetails;
			this.forpayment.amount = parseInt(_.clone(packDetails.precio));
			this.offerSelected.offerId 	= packDetails.id
			this.offerSelected.type 	= packDetails.tipo
			this.showingModal = true;
		},
		
		displayOnly(){
			this.forpayment = {
				amount: 0
			}
			this.offerSelected = _.clone(offerSelected)
			this.showingModal = true;
		},

		getSelectedObj(id) {
			return _.find(this.OfertaGetCatalogo, { id });
		}
		
	},
	watch: {
		'offerSelected.offerId'(){
			try {
				let packDetails = this.getSelectedObj(this.offerSelected.offerId)
				this.setForPayment(packDetails)
			} catch(e){
				console.error(e)
			}
		},
		showingModal() {
			if (this.showingModal) {
				setTimeout(() => {
					this.deviceDataId = OpenPay.deviceData.setup(
						"#openpay-charge-form"
					);
				}, 150);
			} else {
				this.storePaymentResponse = _.clone(storePaymentResponse);
			}
		},
	}
};
</script>

<style lang="less">
#openpay-charge {
	text-align: left;
	#TipoDePago {
		padding: 0.5em;
		label {
			font-weight: bold;
		}
		.payment-option {
			margin: 1em;
		}
	}
	#barcode {
		width: 15em !important;
	}
	#convenience {
		width: 15em;
	}
	#inModalOpenPay {
		img {
			// background: red;
			// border: 1px solid red;
			width: 9em !important;
			position: relative;
			top: -0.4em;
		}
	}
	.download-holder {
		button {
			background: red;
		}
	}
	h2 {
		text-align: center;
		color: #5f00c6;
		font-family: "Open Sans", sans-serif;
		font-size: 1rem;
		font-weight: 600;
		color: #6c757d;
		border-bottom: 1px dashed #cdccd0;
		padding: 1rem;
		margin: 0rem;
	}
	.openpay-locator {
		padding: 0.5em;
		text-align: center;
	}
	.form-group {
		width: calc(100% - 3rem);
		margin: 1rem auto;
	}
	h2 + .form-group {
		margin-top: 0rem;
	}
	#storePaymentResponse {
		text-align: center;
		// max-width: 20em;
		margin: 0 auto;
		IMG {
			margin: 1em;
			width: calc(100% - 2em);
		}
	}
}
</style>